import * as React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { PageTemplate } from '../common/page-template/page-template';

export const NotFoundPage = observer(() => {
  const { t } = useTranslation('', { keyPrefix: 'NOT_FOUND_PAGE' });

  const title = <h2>{t('TITLE')}</h2>;
  const content = <p>{t('MESSAGE')}</p>;

  return <PageTemplate titleElement={title} contentElement={content} />;
});
